{
  "version": 1,
  "asset_id": "e37af9cd-da0e-4ab2-bf2d-d1af13f83b74",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/e37af9cd-da0e-4ab2-bf2d-d1af13f83b74/clip-img_0042.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/e37af9cd-da0e-4ab2-bf2d-d1af13f83b74/clip-img_0042.mp4",
  "original_filename": "clip-img_0042.mp4",
  "size": 333600,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:27Z"
}
